import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { trackPurchase } from '../utils/analytics';

function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Track conversion for Google Ads
    const sessionId = searchParams.get('session_id');
    const tier = searchParams.get('tier') || 'essential';
    if (sessionId) {
      const value = tier === 'premium' ? 100 : 75;
      trackPurchase(sessionId, value);
    }

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/topic-tests');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, searchParams]);

  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '60px auto', 
      padding: '20px',
      textAlign: 'center'
    }}>
      <div className="card" style={{ 
        padding: '60px 40px',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white'
      }}>
        <div style={{ fontSize: '100px', marginBottom: '30px' }}>🎉</div>
        
        <h1 style={{ fontSize: '42px', marginBottom: '20px' }}>
          Payment Successful!
        </h1>
        
        <p style={{ fontSize: '20px', marginBottom: '30px', opacity: '0.95', lineHeight: '1.7' }}>
          Welcome to PrepSmart Premium! Your account has been upgraded and you now have access to all topic-based practice tests.
        </p>

        <div style={{ 
          background: 'rgba(255,255,255,0.2)', 
          padding: '25px', 
          borderRadius: '12px',
          marginBottom: '30px'
        }}>
          <h3 style={{ fontSize: '20px', marginBottom: '15px' }}>What's Next?</h3>
          <ul style={{ 
            textAlign: 'left', 
            fontSize: '16px', 
            lineHeight: '2',
            listStyle: 'none',
            padding: 0
          }}>
            <li>✅ Access to 40+ topic-based practice tests</li>
            <li>✅ Detailed performance analytics</li>
            <li>✅ Progress tracking dashboard</li>
            <li>✅ Priority expert feedback</li>
            <li>✅ One year of premium access</li>
          </ul>
        </div>

        <div style={{ 
          fontSize: '16px', 
          marginBottom: '30px',
          padding: '15px',
          background: 'rgba(255,255,255,0.15)',
          borderRadius: '8px'
        }}>
          Redirecting to Topic Tests in {countdown} seconds...
        </div>

        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button 
            onClick={() => navigate('/topic-tests')}
            className="btn-primary"
            style={{ 
              background: 'white',
              color: '#10b981',
              padding: '15px 40px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            Start Practicing Now →
          </button>
          <button 
            onClick={() => navigate('/dashboard')}
            className="btn-secondary"
            style={{ 
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '2px solid white',
              padding: '15px 40px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            Go to Dashboard
          </button>
        </div>

        <div style={{ 
          marginTop: '40px',
          fontSize: '14px',
          opacity: '0.9'
        }}>
          <p>
            Receipt sent to your email. Questions? Contact us at prepsmart.help@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
